// src/components/Dashboard/Exports.jsx
import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Paper,
  Chip
} from '@mui/material';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  FileDownload,
  Description
} from '@mui/icons-material';

const ExportRow = ({ data, type }) => {
  const [open, setOpen] = useState(false);
  
  const renderData = (rowData) => {
    return (
      <TableRow>
        {Object.entries(rowData).map(([key, value], idx) => (
          <TableCell key={idx}>
            {Array.isArray(value) ? (
              <Box display="flex" gap={1} flexWrap="wrap">
                {value.map((item, i) => (
                  <Chip key={i} label={item} size="small" />
                ))}
              </Box>
            ) : (
              value
            )}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{data.title}</TableCell>
        <TableCell>{type}</TableCell>
        <TableCell>
          <Button
            startIcon={<FileDownload />}
            size="small"
            variant="outlined"
          >
            Download
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Details
              </Typography>
              {data.data || data.records ? (
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {Object.keys(data.data?.[0] || data.records?.[0] || {}).map((header, idx) => (
                          <TableCell key={idx}>{header.replace(/_/g, ' ').toUpperCase()}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.data || data.records).map((row, idx) => renderData(row))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography color="textSecondary">No data available</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const Exports = ({ data }) => {
  const { reports, customerLists } = data;

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Exports & Reports
      </Typography>
      <Card>
        <CardHeader 
          title="Available Exports"
          action={
            <Button
              startIcon={<Description />}
              variant="contained"
              color="primary"
            >
              Export All
            </Button>
          }
        />
        <CardContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width={50} />
                  <TableCell>Title</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reports.map((report, idx) => (
                  <ExportRow key={idx} data={report} type="Report" />
                ))}
                {customerLists.map((list, idx) => (
                  <ExportRow key={idx} data={list} type="Customer List" />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Exports;